import api from "assets/js/public.js";
var getHtml = function (desc) {
  var temp = document.createElement("div");
  // @ts-ignore
  temp.innerHTML = desc;
  var output = temp.innerText || temp.textContent;
  // @ts-ignore
  temp = null;
  return output;
};
export default {
  data() {
    return {
      detail: {}
    };
  },
  created() {
    window.scrollTo(0, 0);
    // @ts-ignore
    api.newDetail({
      unid: this.$route.query.id
    }).then(res => {
      res.data.content = getHtml(res.data.content);
      this.detail = res.data;
    });
  }
};